import { render, staticRenderFns } from "./cv-icon-button.vue?vue&type=template&id=621b2781&"
import script from "./cv-icon-button.vue?vue&type=script&lang=js&"
export * from "./cv-icon-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports